import { createContext } from "react"
const purchase = {
    "discount_type": "cash",
    "invoice_type": 1,
    "total_amount": 0,
    "discount_value": 0,
    "paid_value": 0,
    "change": 0,
    "status": 1,
    "items": [],
    "payments": [],
    "deadline": "",
    "supplier": "",
    "freight": "", 

}
const PurchaseContext = createContext({
    purchase,
    setPurchase: () => {}
});

export default PurchaseContext;


// WEBPACK FOOTER //
// ./src/views/AppViews/Purchases/context.js